import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'

import { colors } from '../../variables.style'

export const Accordion = withStyles({
  root: {
    boxShadow: 'none',
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    },
    '&$expanded:last-child': {
      borderBottom: `1px solid ${colors.borderGray}`
    }
  },
  expanded: {}
})(MuiAccordion)

export const AccordionSummary = withStyles({
  root: {
    backgroundColor: colors.gunMetal,
    color: 'white',
    textTransform: 'uppercase',
    borderBottom: `1px solid ${colors.backgroundGray}`,
    minHeight: 43,
    '&$expanded': {
      minHeight: 43
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {},
  expandIcon: {
    color: 'white',
    fontSize: 14
  }
})((props) => (
  <MuiAccordionSummary expandIcon={(<div className="font-icon-chevron-thin-down" />)} {...props} />
))

export const AccordionDetails = withStyles({
  root: {
    backgroundColor: colors.concrete,
    padding: 10,
    paddingRight: 22
  }
})(MuiAccordionDetails)
